import React from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';

const LegalMentions = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: { xs: 2.5, md: 4 } }}>
        <Typography variant="h3" fontWeight={900} sx={{ mb: 2 }}>
          Mentions légales
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Dernière mise à jour : 18/02/2026
        </Typography>

        <Box sx={{ display: 'grid', gap: 2.25 }}>
          <Typography variant="h6" fontWeight={800}>
            Éditeur
          </Typography>
          <Typography variant="body1">
            SG DIGITAL (micro-entreprise)
            <br />
            Email : sgdigitalweb13@gmail.com
          </Typography>

          <Typography variant="h6" fontWeight={800}>
            Directeur de publication
          </Typography>
          <Typography variant="body1">
            SG DIGITAL
          </Typography>

          <Typography variant="h6" fontWeight={800}>
            Hébergement
          </Typography>
          <Typography variant="body1">
            Hébergeur : à compléter (nom, adresse, contact)
          </Typography>

          <Typography variant="h6" fontWeight={800}>
            Contact
          </Typography>
          <Typography variant="body1">
            Pour toute question : sgdigitalweb13@gmail.com
          </Typography>

          <Typography variant="h6" fontWeight={800}>
            Propriété intellectuelle
          </Typography>
          <Typography variant="body1">
            L’interface, la structure et les contenus du logiciel sont protégés. Toute reproduction non autorisée est interdite.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default LegalMentions;
